import {
  CruiseLiteModel,
  CruiseRoomItemModel,
  CruiseShipsItemModel,
} from 'api-hooks/cruise';
import { GuestLiteModel } from 'api-hooks/guest';
import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

import { CommonMutationInput, SaleLiteModel, SaleModel } from '../common';

// Model

export class CruiseSaleAddOnsItemModel extends CommonModel {
  description: string;
  route?: string | null;

  @Type(() => Number)
  price: number;

  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;
}

export class CruiseSaleGuestItemModel extends CommonModel {
  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  preferences: { id: string; name: string }[];
}

export class CruiseSaleDetailsItemModel extends CommonModel {
  @Expose({ name: 'basic_fare' })
  @Type(() => Number)
  basicFare: number;

  @Expose({ name: 'cruise_room' })
  @Type(() => CruiseRoomItemModel)
  cruiseRoom: CruiseRoomItemModel;

  @Expose({ name: 'cruise_room_number' })
  cruiseRoomNumber: string;

  @Expose({ name: 'cruise_sale_guest_id' })
  cruiseSaleGuestId: string;

  deck: string;
  description: string;

  @Expose({ name: 'port_charge' })
  @Type(() => Number)
  portCharge: number;

  status: string;

  @Type(() => Number)
  tax: number;

  @Type(() => Number)
  tipping: number;
}

export class CruiseSaleCruiseSaleItemModel extends CommonModel {
  @Expose({ name: 'booking_code' })
  bookingCode?: string | null;

  @Type(() => CruiseLiteModel)
  cruise: CruiseLiteModel;

  @Expose({ name: 'cruise_sale_add_ons' })
  @Type(() => CruiseSaleAddOnsItemModel)
  cruiseSaleAddOns: CruiseSaleAddOnsItemModel[];

  @Expose({ name: 'cruise_sale_details' })
  @Type(() => CruiseSaleDetailsItemModel)
  cruiseSaleDetails: CruiseSaleDetailsItemModel[];

  @Expose({ name: 'cruise_sale_guests' })
  @Type(() => CruiseSaleGuestItemModel)
  cruiseSaleGuests: CruiseSaleGuestItemModel[];

  route: string;

  @Expose({ name: 'reschedule_fee' })
  @Type(() => Number)
  rescheduleFee?: number | null;

  @Type(() => Boolean)
  reminder: boolean;

  @Expose({ name: 'reminder_date' })
  @Type(() => Date)
  reminderDate: Date | null;

  @Expose({ name: 'reminder_description' })
  reminderDescription: string | null;

  @Expose({ name: 'is_grouped_price' })
  @Type(() => Boolean)
  isGroupedPrice: boolean;

  @Expose({ name: 'started_at' })
  @Type(() => Date)
  startedAt: Date;

  @Expose({ name: 'ended_at' })
  @Type(() => Date)
  endedAt: Date;

  @Expose({ name: 'cruise_ship' })
  @Type(() => CruiseShipsItemModel)
  cruiseShip: CruiseShipsItemModel;
}

export class CruiseSaleLiteModel extends SaleLiteModel {}

export class CruiseSaleModel extends SaleModel {
  @Expose({ name: 'cruise_sales' })
  @Type(() => CruiseSaleCruiseSaleItemModel)
  cruiseSales: CruiseSaleCruiseSaleItemModel[];
}

export class CruiseSaleGuestsModel extends CommonModel {
  @Type(() => GuestLiteModel)
  guest: GuestLiteModel;

  preferences: { id: string; name: string }[];
}

export class CruiseSaleDetailsModel extends CommonModel {
  @Expose({ name: 'basic_fare' })
  @Type(() => Number)
  basicFare: number;

  @Expose({ name: 'cruise_room' })
  @Type(() => CruiseRoomItemModel)
  cruiseRoom: CruiseRoomItemModel;

  @Expose({ name: 'cruise_room_number' })
  cruiseRoomNumber: string;

  @Expose({ name: 'cruise_sale_guest_id' })
  cruiseSaleGuestId: string;

  deck: string;
  description: string;

  @Expose({ name: 'port_charge' })
  @Type(() => Number)
  portCharge: number;

  status: string;

  @Type(() => Number)
  tax: number;

  @Type(() => Number)
  tipping: number;
}

export class CruiseSaleDetailModel extends CommonModel {
  route: string;
  reminder: boolean;

  @Expose({ name: 'reminder_date' })
  @Type(() => Date)
  reminderDate: Date | null;

  @Expose({ name: 'reminder_description' })
  reminderDescription: string | null;

  @Expose({ name: 'is_grouped_price' })
  @Type(() => Boolean)
  isGroupedPrice: boolean;

  @Type(() => CruiseLiteModel)
  cruise: CruiseLiteModel;

  @Expose({ name: 'cruise_sale_add_ons' })
  @Type(() => CruiseSaleAddOnsItemModel)
  cruiseSaleAddOns: CruiseSaleAddOnsItemModel[];

  @Expose({ name: 'cruise_sale_details' })
  @Type(() => CruiseSaleDetailsModel)
  cruiseSaleDetails: CruiseSaleDetailsModel[];

  @Expose({ name: 'cruise_sale_guests' })
  @Type(() => CruiseSaleGuestsModel)
  cruiseSaleGuests: CruiseSaleGuestsModel[];

  @Expose({ name: 'cruise_ship' })
  @Type(() => CruiseShipsItemModel)
  cruiseShip: CruiseShipsItemModel;

  @Expose({ name: 'booking_code' })
  bookingCode: string | null;

  @Expose({ name: 'ended_at' })
  @Type(() => Date)
  endedAt: Date;

  @Expose({ name: 'started_at' })
  @Type(() => Date)
  startedAt: Date;
}
// Input

export class getCruiseSalesInput {
  params: CommonParamInput & {
    selection?: string;
  };
}

export class getCruiseSaleInput {
  id: string;
}

export class CruiseSaleGuestItemInput {
  id?: string | null;
  guestId: string | null;
  preferences?: string[];
}

export class CruiseSaleDetailsItemInput {
  id?: string | null;
  cruiseRoomNumber: string | null;
  deck: string | null;
  basicFare: number;
  portCharge: number;
  tax: number;
  tipping: number;
  description: string;
  guestId: string | null;
  cruiseRoomId: string | null;
}

export class CruiseSaleAddOnsItemInput {
  id?: string | null;
  guestId: string | null;
  description: string;
  price: number;
}

export class CruiseSaleCruiseSalesItemInput {
  id?: string | null;
  cruiseId?: string | null;
  cruiseShipId?: string | null;
  bookingCode?: string | null;
  startedAt: Date | null;
  endedAt: Date | null;
  route: string;
  isGroupedPrice: boolean;
  reminder: boolean;
  reminderDate?: Date | null;
  reminderDescription?: string | null;

  cruiseSaleGuests: CruiseSaleGuestItemInput[];
  cruiseSaleDetails: CruiseSaleDetailsItemInput[];
  cruiseSaleAddOns: CruiseSaleAddOnsItemInput[];
}

export class CruiseSaleMutationInput extends CommonMutationInput {
  cruiseSales: CruiseSaleCruiseSalesItemInput[];
}

export class CruiseSaleRescheduleItemInput extends CruiseSaleCruiseSalesItemInput {
  rescheduleFee: number;
}

export class CruiseSaleRescheduleMutationInput {
  transactionAt: Date;
  total: number;
  cruiseSales: {
    id: string;
    cruiseId: string;
    bookingCode?: string | null;
    startedAt: Date;
    endedAt: Date;
    route: string;
    isGroupedPrice: boolean;
    reminder: boolean;
    reminderDate?: Date | null;
    reminderDescription?: string | null;
    cruiseSaleGuests: {
      id: string;
      guestId: string;
      preferences: string[];
    }[];
    cruiseSaleDetails: {
      cruiseRoomNumber: string;
      deck: string;
      basicFare: number;
      portCharge: number;
      tax: number;
      tipping: number;
      description: string;
      id: string;
      guestId: string;
      cruiseRoomId: string;
    }[];
    cruiseSaleAddOns: { guestId: string; description: string; price: number }[];
  }[];
}

export class CruiseSaleReschedulePutInput {
  cruiseSaleId: string;
  body: CruiseSaleRescheduleMutationInput;
}

export class CruiseSaleUpdateInput {
  cruiseSaleId: string;
  body: CruiseSaleMutationInput;
}

export class CruiseSaleDeleteInput {
  id: string;
}
